"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _fonts = require("../../fonts");

function getStyles(typescale, viewport) {
  return MicroConfig[typescale][viewport];
}

var MicroConfig = {
  VDS: {
    mobile: {
      fontSize: 11,
      lineHeight: 16,
      fontWeight: 'normal',
      fontFamily: _fonts.Fonts.VerizonNHGeTX
    },
    desktop: {
      fontSize: 11,
      lineHeight: 16,
      fontWeight: 'normal',
      fontFamily: _fonts.Fonts.VerizonNHGeTX
    }
  },
  getStyles: getStyles
};
var _default = MicroConfig;
exports["default"] = _default;